/**
 * Parâmetros fiscais da NFS-e no SIIMP (empresa da DataValue). Vazio = padrão da configuração do
 * backend (Siimp:NfseServicoPadrao / NaturezaFiscalPadrao). Valores lidos das notas emitidas à mão.
 */
export const SIIMP_SERVICOS = [
  { value: "131", label: "1.03 · Processamento, armazenamento ou hospedagem de dados" },
  { value: "144", label: "1.06 · Assessoria e consultoria em informática" },
];

export const SIIMP_NATUREZAS = [
  { value: "1", label: "Tributação no município" },
  { value: "2", label: "Tributação fora do município" },
  { value: "3", label: "Exportação de serviços" },
  { value: "4", label: "Isenção" },
  { value: "5", label: "Imune" },
];
